import { useCallback } from 'react';
import { UseCanvasStateReturn } from './useCanvasState';

export function useLayerOrdering(state: UseCanvasStateReturn) {
  const {
    selectedIds,
    elements,
    setElements,
    layerOrderManagerRef,
  } = state;

  const handleBringToFront = useCallback(() => {
    if (selectedIds.length === 0) return;
    const newElements = layerOrderManagerRef.current?.bringToFront(elements, selectedIds);
    if (newElements) setElements(newElements);
  }, [elements, selectedIds, setElements]);

  const handleSendToBack = useCallback(() => {
    if (selectedIds.length === 0) return;
    const newElements = layerOrderManagerRef.current?.sendToBack(elements, selectedIds);
    if (newElements) setElements(newElements);
  }, [elements, selectedIds, setElements]);

  const handleBringForward = useCallback(() => {
    if (selectedIds.length === 0) return;
    const newElements = layerOrderManagerRef.current?.bringForward(elements, selectedIds);
    if (newElements) setElements(newElements);
  }, [elements, selectedIds, setElements]);

  const handleSendBackward = useCallback(() => {
    if (selectedIds.length === 0) return;
    const newElements = layerOrderManagerRef.current?.sendBackward(elements, selectedIds);
    if (newElements) setElements(newElements);
  }, [elements, selectedIds, setElements]);

  return {
    handleBringToFront,
    handleSendToBack,
    handleBringForward,
    handleSendBackward,
  };
}
